document.addEventListener("DOMContentLoaded", function () {
  // Example: Hide and show product categories on the page

  const categoryButtons = document.querySelectorAll(".category-button");
  const productContainer = document.getElementById("products-container");

  // Example function to filter products based on category
  categoryButtons.forEach(button => {
    button.addEventListener("click", function () {
      const categoryId = button.dataset.categoryId;
      const categoryName = button.textContent.trim();
      loadProducts(categoryId, categoryName);
    });
  });

  function loadProducts(categoryId, categoryName) {
    // Fetch products for the given category
    fetch(`/products/by-category?category=${categoryId}`)
      .then(response => response.json())
      .then(data => {
        if (!data || !data.length) {
          console.error("No products found for category: ", categoryName);
          setStatus(`No products found for ${categoryName}.`);
          return;
        }

        // Clear existing products
        productContainer.innerHTML = '';

        // Display products
        data.forEach(product => {
          const productDiv = document.createElement('div');
          productDiv.classList.add('product-item');
          productDiv.innerHTML = `
            <img src="${product.image}" alt="${product.name}" />
            <h3>${product.name}</h3>
            <p>SKU: ${product.sku}</p>
            <p>Supplier: ${product.supplier}</p>
            <p>Manufacturer: ${product.manufacturer}</p>
            <button class="add-to-cart">Add to Cart</button>
          `;
          productContainer.appendChild(productDiv);
        });
      })
      .catch(error => console.error("Error loading products: ", error));
  }

  // Example status function to show messages (e.g., no products)
  function setStatus(message) {
    const statusElement = document.getElementById("status");
    if (statusElement) {
      statusElement.textContent = message;
    }
  }

  // Example: Add to cart (mock implementation)
  const addToCartButtons = document.querySelectorAll(".add-to-cart");
  addToCartButtons.forEach(button => {
    button.addEventListener("click", function () {
      console.log("Product added to cart!");
    });
  });
});